import { generateCorrectSlug } from '@/helpers/generate-correct-slug';
import { calculatePrefixPath } from '@/helpers/rendered-page-creation/calculate-prefixed-path';
import {
  CONTENT_TYPE_MAP,
  getUrlSubdirectory,
} from '@/helpers/rendered-page-creation/get-url-subdirectories';
import { IMeetingPlaceLinkToAnyPage } from '@/lib/fragments/meetingPlaceLinkToAnyPage';
import {
  useTenantConfig,
  useUrlSubDirectoryDictionary,
} from '@/providers/ConfigProvider';

export const useCalculateSlug = (
  slugData: string | IMeetingPlaceLinkToAnyPage,
): string => {
  const config = useTenantConfig();
  const urlSubdirectories = useUrlSubDirectoryDictionary();

  if (slugData instanceof Object) {
    // check if it is detail page
    if (slugData?.__typename && CONTENT_TYPE_MAP[slugData?.__typename]) {
      const urlSubDirectory = getUrlSubdirectory(
        urlSubdirectories,
        slugData?.sys?.locale,
        slugData?.__typename,
      );
      return generateCorrectSlug(
        slugData,
        config?.GATSBY_SITE_PATH_PREFIX,
        urlSubDirectory,
      );
    }
    return generateCorrectSlug(slugData, config?.GATSBY_SITE_PATH_PREFIX);
  } else if (typeof slugData === 'string') {
    return calculatePrefixPath(slugData, config?.GATSBY_SITE_PATH_PREFIX);
  } else {
    return '';
  }
};
